import { accountEntityName } from '../shared/entities/accountTypes';
export function getAccountStorage(context) {
    return context.storage(accountEntityName);
}
